import { Settings } from 'lucide-react';
import type { ModuleMeta } from '../types';

export const meta: ModuleMeta = {
  id: 'settings',
  label: 'Settings',
  route: '/settings',
  icon: Settings,
};
